<template>
    <div
        class="section-selector"
        :class="{
            '-focus': focus,
            '-disabled': section.disabled || disabled,
            '-success': success,
            '-error': error
        }"
    >
        <div class="input-prefix" v-if="section.prefix">
            {{ section.prefix }}
        </div>
        <textarea
            ref="textInput"
            @keydown.enter="confirmInput(true)"
            :prefix="section.prefix"
            autocomplete="new-password"
            @input="onInput"
            @blur="confirmInput"
            @focus="handleClick"
            :class="{
                '-prefix': section.prefix,
                '-success': success,
                '-error': error
            }"
            :placeholder="placeholder"
            :type="inputType"
            :value="section.value"
            :disabled="section.disabled || disabled"
        />
        <div class="input-prefix" v-if="section.suffix">
            {{ section.suffix }}
        </div>
    </div>
</template>
<script>
export default {
    props: {
        value: [String, Number],
        section: Object,
        success: Boolean,
        error: Boolean,
        blockBlur: Boolean,
        disabled: Boolean
    },
    data() {
        return {
            changesMade: false,
            focus: false
        }
    },
    computed: {
        inputType() {
            switch (true) {
                case this.section.password:
                    return 'password'
                case this.section.type == 'number-input':
                    return 'number'
                default:
                    return 'text'
            }
        },
        placeholder() {
            return this.section.placeholder
                ? this.section.placeholder
                : this.$t('PLACEHOLDER_TYPE_HERE')
        }
    },
    methods: {
        focusInput() {
            this.$refs.textInput.focus()
        },
        handleClick() {
            this.focus = true
            this.$emit('handleClick')
        },
        blur() {
            this.focus = false
        },
        confirmInput(entered) {
            this.focus = false
            if (
                this.changesMade == true &&
                (entered === true || (entered !== true && !this.blockBlur))
            ) {
                this.$emit('confirmInput', this.section, entered)
            } else {
                this.$emit('blur', this.section, entered)
            }
            this.changesMade = false
        },
        onInput($event) {
            this.changesMade = true
            let value = $event.target.value
            if (value === null) {
                this.$emit('input', value)
                return
            }
            if (this.section.type == 'number-input') {
                value = value.replace(',', '.').replace(' ', '')
            }
            this.$emit('input', value)
        }
    }
}
</script>
<style lang="scss" scoped>
.section-selector {
    display: flex;
    overflow: hidden;
    min-height: 10rem;

    textarea {
        padding: 0;
        margin: none;
        outline: none;
        width: 100%;
        height: 100%;
        min-height: 10rem;
        font-size: 1.1rem;
        font-family: $input-family;
        transition: $ease;
        white-space: pre-wrap;
        border: none;
        resize: vertical;

        padding: 0 1rem;
        border-radius: $small-radius;
        margin-right: 0.5rem;
        background: transparent;
        color: var(--color);

        &:focus {
            border-color: $accent-green;
        }

        &.-prefix {
            padding: 0 3rem 0 1rem;
        }

        &.-error {
            border-color: $accent-red;
            color: $accent-red;
            background: lighten($accent-red, 30%);
            &::placeholder {
                color: rgb(150, 150, 150);
            }
        }
        &.-success {
            border-color: $accent-green;
            background: lighten($accent-green, 50%);
        }

        &::placeholder {
            color: $input-placeholder;
        }
    }
}
.input-prefix {
    margin: 0 1rem;
    color: $smoked;
    text-transform: uppercase;
}
</style>
